import { Avatar, Card, Text } from '@change/ds-core-ui/next';

import { Translate, TranslatePlural } from '@change-corgi/core/react/i18n';
import { VisuallyHidden } from '@change-corgi/design-system-legacy/a11y';

import type { ParsedPromotion } from '../../types';

export function PromotionCard({ promotion }: { promotion: ParsedPromotion }) {
	const { amountFormatted, fulfilled, createdAtRelativeLocalized, stats, user } = promotion;
	return (
		<Card orientation="vertical" className="w-[200px] gap-2 border-[1.5px] p-4">
			{fulfilled ? (
				<Text size="x-small" fontWeight="bold" className="text-icon-success">
					<Translate value="corgi.petition.starter_dashboard_v2.petition_insights.promotion_list.status.completed" />
				</Text>
			) : (
				<Text size="x-small" fontWeight="bold" className="text-icon-information">
					<Translate value="corgi.petition.starter_dashboard_v2.petition_insights.promotion_list.status.in_progress" />
				</Text>
			)}

			<div className="flex flex-nowrap items-center gap-2">
				<Avatar className="z-0 [&>img]:min-w-8" alt="avatar" size={32} src={user.photo} />
				<div className="flex flex-col">
					<Text size="x-small" fontWeight="bold" truncate>
						{user.displayName}
					</Text>
					<Text size="x-small" className="text-typography-weak" truncate>
						{!amountFormatted ? createdAtRelativeLocalized : `${amountFormatted} • ${createdAtRelativeLocalized}`}
					</Text>
				</div>
			</div>

			{stats && (
				<div data-testid="promotion-stats" className="flex flex-row gap-2">
					<div className="flex flex-grow flex-col">
						<Text size="x-small" fontWeight="bold" className="text-typography-strong">
							{fulfilled ? (
								stats.impressionsTotalLocalized
							) : (
								<>
									<VisuallyHidden>
										<TranslatePlural
											value="corgi.petition.starter_dashboard_v2.petition_insights.promotion_list.in_progress_views_a11y"
											count={stats.impressionsServed}
											replacements={{
												impressionsServed: stats.impressionsServedLocalized,
												impressionsTotal: stats.impressionsTotalLocalized,
											}}
										/>
									</VisuallyHidden>
									<p aria-hidden>{`${stats.impressionsServedLocalized}/${stats.impressionsTotalLocalized}`}</p>
								</>
							)}
						</Text>
						<Text size="x-small" className="text-typography-weak">
							<TranslatePlural
								value="corgi.petition.starter_dashboard_v2.petition_insights.promotion_list.views"
								count={stats.impressionsServed}
							/>
						</Text>
					</div>
					<div className="flex flex-grow flex-col">
						<Text size="x-small" fontWeight="bold" className="text-typography-strong">
							{stats.signatureCountLocalized}
						</Text>
						<Text size="x-small" className="text-typography-weak">
							<TranslatePlural
								value="corgi.petition.starter_dashboard_v2.petition_insights.promotion_list.signatures"
								count={stats.signatureCount}
							/>
						</Text>
					</div>
				</div>
			)}
		</Card>
	);
}
